import { BaseDto } from "src/dtos/common/baseDto";

/** hrm_code_allow_deduct의 API 필드와 그리드의 신규·수정 상태를 표현한다. */
export interface HrmCodeAllowDeductDto extends BaseDto {
    allowDeductCd: string; // 수당·공제코드(PK). 급여 계산이 P01·D01 같은 값을 직접 참조한다.
    allowDeductNm: string; // 항목명
    allowDeductType: string; // 구분. A 지급, D 공제 (AD_TYPE)
    taxType: string; // 과세구분. T 과세, N 비과세, - 해당없음 (TAX_TYPE)
    ordinaryYn: string; // 통상임금 포함여부(Y/N). 공제는 항상 N
    nontaxLimit: number; // 월 비과세 한도(원). 과세구분 N 지급 항목만 사용, 0 = 한도 없음
    salaryYn: string; // 지급은 급여대상, 공제는 급여공제 여부(Y/N)
    bonusYn: string; // 지급은 상여대상, 공제는 상여공제 여부(Y/N)
    useYn: string; // 사용여부(Y/N)
    sortSeq: number; // 조회 순서
    remark: string; // 비고 / 연결 기준표
    inserted: boolean; // true이면 아직 서버에 저장하지 않은 신규 행
    isModified: boolean; // true이면 조회 후 값을 바꾼 기존 행
}

/** DB 기본값과 같게 사용 Y·급여 Y·상여 N·통상임금 N·비과세한도 0으로 시작하는 엔티티 DTO 기본값이다. */
export const defaultHrmCodeAllowDeductDto: HrmCodeAllowDeductDto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
    allowDeductCd: '',
    allowDeductNm: '',
    allowDeductType: '',
    taxType: '',
    ordinaryYn: 'N',
    nontaxLimit: 0,
    salaryYn: 'Y',
    bonusYn: 'N',
    useYn: 'Y',
    sortSeq: 0,
    remark: '',
    inserted: false,
    isModified: false,
};
